import React from 'react';
import { Icon } from '../../../components/ui/Icon';
import { ShippingType } from '../../../components/calculator/components';

interface PackageTypeSelectorProps {
  selectedType: ShippingType;
  onChange: (type: ShippingType) => void;
}

const TYPES: Array<{ value: ShippingType; label: string; icon: string; sub: string }> = [
  { value: 'package', label: 'Package', icon: 'package', sub: 'Box or parcel with dimensions' },
  { value: 'document', label: 'Document', icon: 'file', sub: 'Envelope up to 0.5 kg' },
];

export const PackageTypeSelector: React.FC<PackageTypeSelectorProps> = ({
  selectedType,
  onChange,
}) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <div className="muted" style={{ fontSize: 13, marginBottom: 10 }}>
        What are you shipping?
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {TYPES.map((type) => {
          const active = selectedType === type.value;
          return (
            <button
              key={type.value}
              type="button"
              onClick={() => onChange(type.value)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '12px 16px',
                borderRadius: 8,
                border: active ? '2px solid var(--blue)' : '1px solid var(--border)',
                background: active ? 'var(--blue-soft, #eff6ff)' : 'var(--surface)',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'border-color 0.15s',
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  background: active ? 'var(--blue)' : 'var(--surface-2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <Icon
                  name={type.icon as any}
                  size={18}
                  style={{ color: active ? '#fff' : 'var(--ink-2)' }}
                />
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: active ? 'var(--blue)' : 'var(--ink)' }}>
                  {type.label}
                </div>
                <div className="muted" style={{ fontSize: 12 }}>{type.sub}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
